import { AxiosRequestConfig, AxiosResponse } from "axios";
import { getAxiosInstances } from "../../../../utils/AppUtils";
import AxiosActions from "../../AxiosActions";

interface IGraphQlError {
    message?: string;
    path?: string[];
    extensions?: Record<string, unknown>;
}

export interface IGraphQlEnvelope<T = any> {
    data?: T;
    errors?: IGraphQlError[];
}

export const graphQlRequest = <T = any>(query: any, spinner: boolean, config: AxiosRequestConfig = {}): Promise<AxiosResponse<T>> => {
    return AxiosActions.post(getAxiosInstances()?.graphqlInstance, `graphql`, query, { ...config }, spinner, false);
};

export const unwrapGraphQlResponse = <T>(res: AxiosResponse<IGraphQlEnvelope<T>>): T => {
    const errors = res.data?.errors;
    if (errors && errors.length > 0) {
        const message = errors
            .map((e) => e?.message)
            .filter(Boolean)
            .join("; ");
        const err = new Error(message || "GraphQL request returned errors") as Error & { graphQlErrors?: IGraphQlError[] };
        err.graphQlErrors = errors;
        throw err;
    }
    if (!res.data?.data) {
        throw new Error("GraphQL request returned no data");
    }
    return res.data.data;
};
